import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  hasUserAcceptedQuote: { jobId: null }
}

export const quoteSlice = createSlice({
    name: "quote",
    initialState,
    reducers: {
        acceptQuoteAsUser: (state, action) => {
            state.hasUserAcceptedQuote = action.payload
        },
    }
})

export const { acceptQuoteAsUser } = quoteSlice.actions
export default quoteSlice.reducer